// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1gmIQ","header":"PatientQuestionnaire_header__2Uk-Q","info":"PatientQuestionnaire_info__2CnHi"};